<template>
    <validation-observer ref="form" v-slot="{ meta, setValues }">
        <modal :id="modalId" title="Add Property" @hide="hideModal" @show="showModal" :static="true">
            <busy-modal :show="loading"></busy-modal>
            <b-form v-if="availablePropertiesOptions.length > 1">
                <b-row>
                    <b-col>
                        <validation-provider name="property" v-slot="{ errors }" rules="required" >
                            <form-select
                                class="mb-2"
                                v-model="selectedProperty"
                                :options="availablePropertiesOptions"
                                :error="errors[0]"
                                @input="(val) => setValues({ property: val })"
                            ></form-select>
                        </validation-provider>
                    </b-col>
                </b-row>
            </b-form>
            <span v-else>
                <b-row>
                    <b-col>
                        There's no available properties.
                    </b-col>
                </b-row>
            </span>
            <template #modal-footer="{ ok, cancel }">
                <div>
                    <b-button
                        @click="cancel"
                        v-if="availablePropertiesOptions.length > 2"
                        variant="secondary"
                        class="mr-2"
                    >
                        Cancel
                    </b-button>
                    <b-button
                        :disabled="!meta.valid || loading"
                        variant="primary"
                        class="float-right"
                        @click="addProperty"
                    >
                        Save
                    </b-button>
                </div>
            </template>
        </modal>
    </validation-observer>
</template>

<script>
    import { mapGetters } from 'vuex';
    import isEmpty from 'lodash/isEmpty';
    import API from '../../../api';
    import { formatResponseError } from '../../../utils/api';
    import BusyModal from '../../generic/busy-modal/busy-modal.vue';
    import Modal from '../../generic/modal/modal.vue';
    import FormSelect from '../../generic/form-select/form-select.vue';
    import { RESERVATION_DETAILS_AVAILABLE_PROPERTIES_ENDPOINT } from '../../../endpoints';

    export default {
        name: 'AddPropertyModal',
        components: {
            BusyModal,
            FormSelect,
            Modal,
        },
        inject: ['getAvailablePropertiesRequestData'],
        props: {
            modalId: String,
        },
        computed: {
            ...mapGetters('reservation', ['reservationDetails']),
            availablePropertiesOptions() {
                let options = [{ value: null, text: 'Please select a property' }];
                for (let i = 0; i < this.properties.length; i++) {
                    options.push({
                        value: this.properties[i].property_id + '-' + this.properties[i].room_id || 0,
                        text: this.properties[i].name,
                    });
                }
                return options;
            },
        },
        data() {
            return {
                loading: false,
                selectedProperty: null,
                properties: [],
            };
        },
        methods: {
            hideModal() {
                this.$bvModal.hide(this.modalId);
            },
            showModal() {
                this.selectedProperty = null;
                (async () => {
                    this.loading = true;
                    try {
                        await Promise.all([this.fetchProperties()]);
                    } finally {
                        this.loading = false;
                    }
                })();
            },
            async fetchProperties() {
                try {
                    const data = this.getAvailablePropertiesRequestData();
                    const response = await API.post(RESERVATION_DETAILS_AVAILABLE_PROPERTIES_ENDPOINT(), data);
                    this.properties = response.data;
                } catch (e) {
                    this.$bvModal.hide(this.modalId);
                    this.errorToast({
                        text: e.response?.data?.message || 'Error: Could not load properties.',
                    });
                }
            },
            addProperty() {
                for (let i = 0; i < this.properties.length; i++) {
                    const id = this.properties[i].property_id + '-' + this.properties[i].room_id || 0;
                    if (this.selectedProperty == id) {
                        this.reservationDetails.properties.push(this.properties[i]);
                    }
                }
                this.hideModal();
            },
        },
    };
</script>
